import Reveal from '@/components/base/Reveal';

export default function NumberedSteps({ steps }: { steps: { t: string; d: string }[] }) {
  return (
    <ol className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
      {steps.map((s, i) => (
        <Reveal key={s.t} delay={i * 100}>
          <li className="border-t border-foreground-950/80 pt-6 list-none">
            <p className="em-serif text-[44px] md:text-[56px] leading-none text-secondary-500">{String(i + 1).padStart(2, '0')}</p>
            <h3 className="mt-5 text-[21px] md:text-[23px] font-medium">{s.t}</h3>
            <p className="mt-3 text-[15px] md:text-[16px] leading-relaxed text-foreground-700 max-w-xs">{s.d}</p>
          </li>
        </Reveal>
      ))}
    </ol>
  );
}